
<div class="indeterminate-bar" *ngIf="pinLoading">
    <div class="bar"></div>
</div>

<div id="map" style="height: 100%; width: 100%;">

    <!-- <div *ngIf="spinner" class="map-spinner">
        <nz-spin [nzSpinning]="true"></nz-spin>
    </div> -->


    <div class="floating-toolbar">
        <button nz-button nzShape="circle" nz-popover nzPopoverContent="Area drawing" nzType="text" *ngIf="currentUser?.makeAreas && notYouPeenz" [disabled]="pinLoading" (click)="setMapDrawing()">
            <span nz-icon nzType="layout" nzTheme="fill" [style.color]="drawingMode ? '#1890ff' : pinLoading ? '#7f7f7f' : '#000000'"></span>
        </button>
    
        <button nz-button nzShape="circle" nz-popover nzPopoverContent="Area selection" nzType="text" [disabled]="pinLoading" (click)="setAreaSelection()">
            <span nz-icon nzType="tool" nzTheme="fill" [style.color]="areaSelection ? '#1890ff' : pinLoading ? '#7f7f7f' : '#000000'"></span>
        </button>

        <button *ngIf="hasPermission('move-pins')" nz-button nzShape="circle" nz-popover nzPopoverContent="Move pins" nzType="text" [disabled]="pinLoading" (click)="setMoveMode()">
            <span nz-icon nzType="drag" [style.color]="movePins ? '#1890ff' : '#000000'"></span>
        </button>
    
        <button nz-button nzShape="circle" nzType="text" nz-popover nzPopoverContent="Pin dropping" *ngIf="currentUser?.makePins && notYouPeenz" [disabled]="pinLoading" (click)="setMarkerMode()">
            <span nz-icon nzType="environment" nzTheme="fill" [style.color]="markerMode ? '#1890ff' : pinLoading ? '#7f7f7f' : '#000000'"></span>
        </button>
    
        <button nz-button nzShape="circle" nzType="text" nz-popover nzPopoverContent="Change map type" [disabled]="pinLoading" (click)="showStyles()">
            <span nz-icon nzType="switcher" nzTheme="fill" [style.color]="showStyleBar ? '#1890ff' : pinLoading ? '#7f7f7f' : '#000000'"></span>
        </button>
    
        <button nz-button nzShape="circle" nzType="text" nz-popover nzPopoverContent="Location tracking" (click)="setLiveTracking()">
            <span nz-icon nzType="eye" nzTheme="fill" [style.color]="liveTracking ? '#1890ff' : '#000000'"></span>
        </button>
    </div>


    <div class="floating-toolbar-sub" *ngIf="showStyleBar">
        <button *ngFor="let style of styles"  nz-button nzShape="circle" nzType="text"  (click)="setMapStyle(style.url)">
            <span nz-icon [nzType]="style.icon" [nzTheme]="style.theme" [style.color]="style.url == mapStyle ? '#1890ff' : '#000000'"></span>
        </button>
    </div>

</div>

<nz-modal [(nzVisible)]="showCreateAreaModal" [nzFooter]="null" nzTitle="Create Area" (nzOnCancel)="showCreateAreaModal = false; cancelDrawing()">
    <ng-container *nzModalContent>
        <form [formGroup]="newAreaForm">

            <nz-form-item>
                <nz-form-label>Select User(s)</nz-form-label>
                <nz-select  nzMode="multiple" nzPlaceHolder="Select Rep" formControlName="users" style="width: 100%;" [nzShowSearch]="true">
                    <nz-option *ngFor="let u of users" [nzLabel]="u.first_name + ' ' + u.last_name + '(' + u.company + ')'" [nzValue]="u"></nz-option>
                  <!-- <nz-option *ngFor="let u of users" [nzLabel]="u.first_name + ' ' + u.last_name" [nzValue]="u.id"></nz-option> -->
                </nz-select>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Color</nz-form-label>
                <input type="color" formControlName="color"/>
            </nz-form-item>

        </form>

        <nz-form-item>
            <nz-form-label>{{selectedDisposCount}} selected to assign</nz-form-label>
            <div class="chip-scroll">
                <nz-tag *ngFor="let d of newAreaStats" nzMode="checkable" [nzChecked]="selectedDispos?.includes(disp?.id)" (click)="handleDispoClicked(d)">
                    <span nz-icon nzType="down-circle" [style.color]="d.color" [style.background]="d.color" [style.border-radius]="'50%'" nzTheme="fill" ></span>
                    {{d.disposition}} ({{d.count}})
                </nz-tag>
            </div>
        </nz-form-item>

        <nz-radio-group *ngIf="newAreaStats" style="padding: 10px;" [(ngModel)]="subSegment" (ngModelChange)="subSegmentChange($event)" nzButtonStyle="solid">
            <label nz-radio-button [nzValue]="'graph'">
                <span nz-icon nzType="pie-chart" nzTheme="outline"></span>
            </label>

            <label nz-radio-button [nzValue]="'list'">
                <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
            </label>
        </nz-radio-group>

        <nz-card *ngIf="newAreaStats" style="margin-top: 5px;" [ngClass]="{ 'hidden': subSegment !== 'graph' }" nzTitle="Pins by Disposition">
            <canvas #pieChartAdd width="400" height="400"></canvas>
        </nz-card>

        <nz-card style="margin-top: 5px;" [ngClass]="{ 'hidden':subSegment !== 'list' }" nzTitle="Pins by Disposition">
            <nz-list>
                <nz-list-item *ngFor="let disp of sortArr(newAreaStats)">
                    <span nz-typography>{{disp.disposition}}</span>
                    {{disp.count}}
                </nz-list-item>
            </nz-list>
        </nz-card>

        <div class="action-sheets-options">
            <button nz-button nzType="primary" (click)="saveNewArea()">Create Area</button>
            <button nz-button nzType="default" (click)="showCreateAreaModal = false; setMapDrawing()">Cancel</button>
        </div>


    </ng-container>
</nz-modal>
 



<nz-drawer [nzClosable]="false" [nzVisible]="showDrawer" nzPlacement="bottom" [nzTitle]="drawerTitle">
    <ng-container *nzDrawerContent>
        <div class="action-sheets-options">
            <button nz-button nzType="primary" (click)="assignAndSave()">Assign & Save Area</button>
            <button nz-button nzType="primary" (click)="cancelDrawing()" nzDanger>Cancel Drawing</button>
        </div>
    </ng-container>
</nz-drawer>

<nz-drawer [nzVisible]="showFilterDrawer" nzPlacement="right" nzTitle="Map Filter" (nzOnClose)="showFilterDrawer = false">
    <ng-container *nzDrawerContent>

        <form [formGroup]="filterForm">

            <nz-form-item>
                <nz-form-label nzRequired>Select Provider</nz-form-label>
                <nz-select nzPlaceHolder="Select Provider" formControlName="provider" style="width: 100%;" [nzShowSearch]="true">
                  <nz-option *ngFor="let p of currentUser?.providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                </nz-select>
                <a *ngIf="currentUser?.providers?.length > 1" (click)="setDefault()" style="padding-left: 5px; padding-top: 2px;">Set Default Provider</a>
            </nz-form-item>

            <nz-form-item *ngIf="hasPermission('view_distributor_companies')">
                <nz-form-label>Select Company</nz-form-label>
                <nz-select  nzPlaceHolder="Select Company" formControlName="company" style="width: 100%;" [nzShowSearch]="true">
                  <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
                </nz-select>
            </nz-form-item>

            <nz-form-item *ngIf="users?.length > 0">
                <nz-form-label>Select User</nz-form-label>
                <nz-select  nzPlaceHolder="Select Rep" formControlName="user" style="width: 100%;" [nzShowSearch]="true" [compareWith]="compareUser">
                  <nz-option *ngFor="let u of users" [nzLabel]="u.first_name + ' ' + u.last_name  + '(' + u.company + ')'" [nzValue]="u"></nz-option>
                </nz-select>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Dispositions</nz-form-label>
                <div class="chips">
                    <nz-tag *ngFor="let d of dispositions" nzMode="checkable" [nzChecked]="filterForm?.get('disposition')?.value?.includes(d?.id)" (click)="setClickedFilterDispo(d)">
                        <span nz-icon nzType="down-circle" [style.color]="d.pin" [style.background]="d.pin" [style.border-radius]="'50%'" nzTheme="fill" ></span>
                        {{d.disposition}}
                    </nz-tag>
                </div>
            </nz-form-item>

        </form>

        <div class="action-sheets-options">
            <button nz-button nzType="primary" (click)="showFilterDrawer = false; pinLoading = true; getAreas();">Apply Filter</button>
            <button nz-button nzType="default" (click)="resetFilter()">Reset</button>
        </div>
    </ng-container>
</nz-drawer>


  